import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import MuiLink from '@material-ui/core/Link';
import SkeletonBody from '@afosto/components-react/SkeletonBody';
import { calculations as calculationsApi } from '@afosto/order/api/Calculations';

const CalculationFormatter = ({ id }) => {
  const [calculation, setCalculation] = useState(null);
  const [isLoadingCalculation, setIsLoadingCalculation] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchCalculation = async () => {
      setIsLoadingCalculation(true);

      try {
        const response = await calculationsApi.getCalculation(id);
        if (isMounted) {
          setCalculation(response?.data ?? null);
        }
      } catch (err) {
        if (isMounted) {
          setCalculation(null);
        }
      } finally {
        if (isMounted) {
          setIsLoadingCalculation(false);
        }
      }
    };

    if (id) {
      fetchCalculation().catch(() => {
        // Catch only
      });
    } else if (isMounted) {
      setIsLoadingCalculation(false);
    }

    return () => {
      isMounted = false;
    };
  }, [id]);

  if (!calculation) {
    return '-';
  }

  if (isLoadingCalculation) {
    return <SkeletonBody lines={1} />;
  }

  return (
    <MuiLink variant="subtitle1" component={Link} to={`/calculations/${id}`}>
      {calculation.number ?? '-'}
    </MuiLink>
  );
};

CalculationFormatter.propTypes = {
  id: PropTypes.string,
};

CalculationFormatter.defaultProps = {
  id: undefined,
};

export default CalculationFormatter;
